import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blog-schedule',
  templateUrl: './blog-schedule.component.html',
  styleUrls: ['./blog-schedule.component.scss']
})
export class BlogScheduleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
